
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../../services/transports';
import { searchStakeholderUsers } from '../../../api/stakeholderUsers';
import { LabeledSelect } from '..';

export const SearchStakeholderUsers = ({
  label,
  id,
  onChange,
  withAsterisks,
  disabled,
  shId,
  placeholder,
  disableSearch = false,
  allowClear = true,
  value }) => {
  const [ { data }, fetchSearch ] = useFetch(searchStakeholderUsers,
    response => (
      response?.data?.container
        ? response.data.container.map(item => ({ value: `${item.id}`, text: `${item.name} ${item.gln}` }))
        : []));


  const [ t ] = useTranslation();

  useEffect(() => {
    // const options = data.slice().map(item => ({ value: `${item.shId}`, text: `${item.name} ${item.gln}` }));
    shId && fetchSearch({ shId });
  }, [ shId ]);

  const onSearchStakeholderUser = useCallback(query => {
    !disableSearch && !!query && fetchSearch({ shId: query.trim() });
  }, [ fetchSearch ]);

  return (
    <LabeledSelect
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      withDebounceSearch={ true }
      onSearch={ onSearchStakeholderUser }
      searchDelay={ 1000 }
      options={ data }
      filterOption={ false }
      EmptyComponent={ t('ERR.noMatchedSH') }
      withAsterisks={ withAsterisks }
      disabled={ disabled }
      allowClear={ allowClear }
      placeholder={ placeholder }
      value={ value }
    />
  );
};
